import axios from "@/axios.config";
import { ApprovalEntry } from "@/types/educationbackground.type";
import { ApiResponse } from "@/types/fetch.type";
import { useQuery, useMutation } from "@tanstack/react-query";

export const useGetAllApprovalStructures = () => {
    return useQuery<ApiResponse<ApprovalEntry[]>>({
        queryKey: ["approval-structures"],
        queryFn: async () => {
            const response = await axios.get("/approvalstructurelevel");
            return response.data;
        },
        refetchOnWindowFocus: false,
    });
};

interface CreateApprovalStructureDTO {
    council_id: string;
    role_id: string;
    approvalLevel: number;
}

export const useCreateApprovalStructure = () => {
    return useMutation<ApiResponse<ApprovalEntry>, Error, CreateApprovalStructureDTO>({
        mutationFn: async (data) => {
            const response = await axios.post("/approvalstructurelevel", data);
            return response.data;
        },
    });
};

interface EditApprovalStructureDTO extends Partial<CreateApprovalStructureDTO> {
    id: string;
}

export const useEditApprovalStructure = () => {
    return useMutation<ApiResponse<ApprovalEntry>, Error, EditApprovalStructureDTO>({
        mutationFn: async (data) => {
            const response = await axios.put(`/approvalstructurelevel/${data.id}`, data);
            return response.data;
        },
    });
};

export const useDeleteApprovalStructure = () => {
    return useMutation<ApiResponse<ApprovalEntry>, Error, string>({
        mutationFn: async (id) => {
            const response = await axios.delete(`/approvalstructurelevel/${id}`);
            return response.data;
        },
    });
};